import defaultTheme from "@/themes/theme";

export const styles = {
  mainContainer: {
    backgroundColor: "grey.50",
    "& .topBar": {
      backgroundColor: "grey.200",
      justifyContent: "space-between",
    },
  },

  wrapper: {
    backgroundColor: "grey.300",
    height: "212px",
    width: "calc(100% - 80px)",
    mt: "70px",
    ml: "80px",
  },

  container: {
    [defaultTheme.breakpoints.down("md")]: {
      p: 0,
      pt: 4,
    },
    p: 2,
  },

  boxColumns: {
    [defaultTheme.breakpoints.down("md")]: {
      p: 0,
    },
    p: 4,
  },

  boxSingleColumn: {
    [defaultTheme.breakpoints.down("md")]: {
      p: 0,
    },
    display: "flex",
    justifyContent: "center",
    p: 4,
    "& .MuiPaper-root": {
      width: "700px",
    },
  },
};
